<div
  class="component-container text-cool-grey h-full flex flex-col justify-center items-center"
>
  <div class="login-form-container md:w-[80%] w-full justify-center p-[4rem]">
    <div
      class="heading font-poppins font-bold mb-[2.4rem] flex justify-center items-center gap-[0.8rem]"
    >
      Sign In
      <app-icon
        [matTooltip]="signInTooltipText"
        class="tooltip-icon"
        matTooltipClass="custom-tooltip sign-in-tooltip"
        matTooltipPosition="below"
        svgIcon="info"
      />
    </div>
    <form [formGroup]="form" (ngSubmit)="login()">
      <div class="username">
        <div class="form-field-label small flex flex-row justify-between">
          <div class="label flex flex-row content-center">
            Username
            <span class="required-mark ml-[0.3rem]">*</span>
          </div>
        </div>
        <mat-form-field
          appearance="outline"
          class="form-field w-full small"
          hideRequiredMarker
        >
          <input
            formControlName="username"
            class="input small text-input"
            matInput
            placeholder="Username"
            type="text"
            autocapitalize="none"
            autocorrect="off"
            spellcheck="false"
            autocomplete="username"
            appInputRestriction="noUpperCaseAlphabets"
            [parentFormGroup]="form"
            controlName="username"
          >
        </mat-form-field>
      </div>
      <div class="username">
        <div class="form-field-label small flex flex-row w-full justify-between">
          <div class="password-label">
            Password
            <span class="required-mark">*</span>
          </div>
          <div
            class="forgot-password link underline text-digital-blue-light cursor-pointer"
            (click)="forgotPassword()"
          >
            Forgot Password
          </div>
        </div>
        <mat-form-field
          appearance="outline"
          class="form-field w-full small"
          hideRequiredMarker
        >
          <input
            formControlName="password"
            class="input small text-input"
            matInput
            placeholder="Password"
            [type]="showPassword ? 'text' : 'password'"
          >
          <div
            (click)="togglePasswordVisibility()"
            class="suffix-icon-section bg-palo-verde rounded-full border border-[#1E282A] border-px box-border"
            matSuffix
          >
            <app-icon
              [svgIcon]="suffixIcon"
              class="suffix-icon"
            >
            </app-icon>
          </div>
        </mat-form-field>
      </div>
      <app-primary-button
        class="action-panel mt-[2.4rem]"
        type="small"
        (handleClick)="login()"
        [isDisabled]="form.invalid"
        [isLoading]="loading"
      >
        SIGN IN
      </app-primary-button>
    </form>
  </div>
</div>
